import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

function ScrollToTop() {

    window.scrollTo(0,0)
    const {pathename} = useLocation()
    useEffect(()=>{
    },[pathename])
  return null
}

export default ScrollToTop